import React from 'react';
import './TechnologiesBlock.css';
import PropTypes from 'prop-types';

const TechnologiesBlock = (props) => {
  const {
    technologies,
  } = props;
  const technosDiv = [];
  technologies.forEach((techno) => {
    technosDiv.push(
      <div key={techno}>
        {techno}
      </div>,
    );
  });
  return (
    <div className="header">
      <div className="serviceview_technos_title">
            technologies
      </div>
      <div className="serviceview_technos_container">
        {technosDiv}
      </div>
    </div>
  );
};

TechnologiesBlock.propTypes = {
  technologies: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TechnologiesBlock;



// WEBPACK FOOTER //
// ./src/components/TechnologiesBlock/TechnologiesBlock.jsx